/* Product Page CRO — cart drawer oil reminder.

   SPEED: both oil collections are fetched on page load and kept in memory, and
   the cart is cached and updated from every /cart/add.js response the page
   makes. When the drawer opens there is nothing left to fetch, so the block
   renders in the same frame. Earlier versions fetched after the drawer opened,
   which was slow enough that customers reached checkout first.

   Injected via JS so the cart-drawer section is never edited.

   PRICES: /collections/<handle>/products.json returns DECIMAL STRINGS
   ("284.00"); /cart.js uses cents. Do not mix them. */
(function () {

  // Diffusers that run on refillable aroma oil.
  // Car diffuser excluded — sealed cartridges, not oil.
  var DIFFUSERS = {
    '15458112438641': 'aroma-oil',  // AIRSLIM
    '15458119156081': 'aroma-oil',  // SCENT PRO
    '15458119287153': 'aroma-oil',  // ECO SCENT
    '15458114634097': 'aroma-oil',  // AIRCENT
    '15458114535793': 'aroma-oil',  // SCENT BOX
    '15458122793329': 'aroma-oil',  // SCENT SPLASH
    '15458123219313': 'aroma-oil',  // SCENT TRIO
    '15458119352689': 'aroma-oil',  // AIRMAX+
    '15458122957169': 'aroma-oil',  // AIRMAX NOVO
    '15458114503025': 'aroma-oil',  // SENSEI PLUG-IN
    '15533992771953': 'mino-oils'   // MINO
  };

  var HANDLES = ['aroma-oil', 'mino-oils'];
  var SHOW = 4;

  var sets = {};        // handle -> { items, ids }
  var lastCart = null;  // most recent cart we know about

  function money(v) {
    var n = parseFloat(v);
    return isFinite(n) ? 'AED ' + n.toFixed(2) : '';
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  function load(handle) {
    if (sets[handle]) return Promise.resolve(sets[handle]);
    return fetch('/collections/' + handle + '/products.json?limit=40', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var ids = {};
        var items = (data.products || []).map(function (p) {
          ids[p.id] = true;
          var v = null;
          (p.variants || []).forEach(function (x) {
            if (!v && x.available && String(x.title).toLowerCase().replace(/\s/g, '').indexOf('500ml') > -1) v = x;
          });
          if (!v) (p.variants || []).forEach(function (x) { if (!v && x.available) v = x; });
          if (!v) return null;
          return {
            title: String(p.title).replace(/\s*\d+\s*ml\s*$/i, ''),
            variantId: v.id,
            price: v.price,
            image: (p.images && p.images[0]) ? p.images[0].src : ''
          };
        }).filter(Boolean);
        sets[handle] = { items: items, ids: ids };
        return sets[handle];
      })
      .catch(function () { sets[handle] = { items: [], ids: {} }; return sets[handle]; });
  }

  function findDrawer() {
    return document.querySelector(
      '.hdt-cart-drawer, #hdt-cart-drawer, cart-drawer, [data-cart-drawer], .cart-drawer'
    );
  }

  function findFooter(drawer) {
    return drawer.querySelector(
      '.hdt-cart-drawer__footer, .cart-drawer__footer, [data-cart-footer], .hdt-cart__footer, footer'
    );
  }

  function build(items, handle) {
    var wrap = document.createElement('div');
    wrap.className = 'cro-dwr';
    wrap.setAttribute('data-cro-dwr', '');

    var html =
      '<div class="cro-dwr__head">' +
        '<span class="cro-dwr__title">Your diffuser needs oil</span>' +
        '<a class="cro-dwr__all" href="/collections/' + handle + '">See all</a>' +
      '</div>' +
      '<p class="cro-dwr__sub">IFRA-certified oils, shipped with your order.</p>' +
      '<div class="cro-dwr__row">';

    items.slice(0, SHOW).forEach(function (o) {
      html +=
        '<div class="cro-dwr__card">' +
          (o.image
            ? '<img class="cro-dwr__img" src="' + esc(o.image) + '" alt="" loading="lazy">'
            : '<span class="cro-dwr__img"></span>') +
          '<span class="cro-dwr__name">' + esc(o.title) + '</span>' +
          '<span class="cro-dwr__price">' + money(o.price) + '</span>' +
          '<button type="button" class="cro-dwr__add" data-cro-dwr-add="' + o.variantId + '">Add</button>' +
        '</div>';
    });

    html += '</div>';
    wrap.innerHTML = html;
    return wrap;
  }

  /* synchronous — uses only what is already in memory */
  function paint() {
    var drawer = findDrawer();
    if (!drawer || !lastCart) return;

    var items = lastCart.items || [];
    var handle = null;
    items.forEach(function (i) {
      var h = DIFFUSERS[String(i.product_id)];
      if (!handle && h) handle = h;
    });

    var existing = drawer.querySelector('[data-cro-dwr]');
    if (!handle) { if (existing) existing.remove(); return; }

    var data = sets[handle];
    if (!data) { load(handle).then(paint); return; }

    var hasOil = items.some(function (i) { return data.ids[i.product_id]; });
    if (hasOil || !data.items.length) { if (existing) existing.remove(); return; }
    if (existing) return;

    var footer = findFooter(drawer);
    var node = build(data.items, handle);
    if (footer && footer.parentNode) {
      footer.parentNode.insertBefore(node, footer);
    } else {
      drawer.appendChild(node);
    }
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { lastCart = cart; paint(); })
      .catch(function () {});
  }

  /* keep the cached cart current by watching the page's own add requests */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var p = origFetch.apply(this, arguments);
    try {
      var s = (typeof url === 'string') ? url : (url && url.url) || '';
      if (s.indexOf('/cart/') > -1) {
        p.then(function () { refreshCart(); });
      }
    } catch (e) {}
    return p;
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cro-dwr-add]');
    if (btn) {
      e.preventDefault();
      if (btn.disabled) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = '\u2026';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.croDwrAdd), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          btn.textContent = 'Added';
          btn.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        })
        .catch(function () {
          btn.textContent = original;
          btn.disabled = false;
        });
      return;
    }
    // any other click might open the drawer — paint from cache straight away
    paint();
    setTimeout(paint, 60);
    setTimeout(paint, 250);
  }, true);

  ['cart:refresh', 'cart:build', 'cart:updated', 'cart:open'].forEach(function (evt) {
    document.addEventListener(evt, function () { paint(); setTimeout(refreshCart, 50); });
  });

  new MutationObserver(paint).observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['open', 'class', 'aria-hidden', 'style']
  });

  function start() {
    HANDLES.forEach(load);   // warm both collections up front
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
